"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = AnnotatePen;
var _AnnotatePen = require("@adobe/react-spectrum-workflow/dist/AnnotatePen.js");
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function AnnotatePen(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_AnnotatePen.A4uAnnotatePen, null));
}